// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__MqQNN","skeleton-animation":"styles_skeleton-animation__g260_"};